"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Path = exports.ChainCode = void 0;
const types_1 = require("../../types");
const chainCodeBase = types_1.ByteArray(32);
const chainCodeStatic = {};
const chainCode = Object.assign(chainCodeBase, chainCodeStatic);
exports.ChainCode = chainCode;
// This is the same regex that the bip32 library uses to validate paths.
const pathBase = types_1.BoundedString(/^((m\/)?(\d+'?\/)*\d+'?)$/);
const pathStatic = {};
const path = Object.assign(pathBase, pathStatic);
exports.Path = path;
